// src/components/pages/correlation/utils/urlStateLoader.js

import { subMonths, format } from "date-fns";

export const getInitialStateFromURL = (locationSearch) => {
  const params = new URLSearchParams(locationSearch);
  
  const urlStocks = params.get('stocks');
  const urlRange = params.get('range');
  const urlStart = params.get('start');
  const urlEnd = params.get('end');
  const urlK = params.get('k');

  const today = new Date();
  const defaultStartDate = format(subMonths(today, 36), "yyyy-MM-dd");
  const defaultEndDate = format(today, "yyyy-MM-dd");
  
  let initialStocks = [];
  let isReady = false;

  if (urlStocks) {
    try {
      initialStocks = urlStocks.split(',').map(ticker => ticker.toUpperCase().trim());
      initialStocks = initialStocks.filter(stock => stock.length > 0);
      if (initialStocks.length >= 3) {
        isReady = true; 
      }
    } catch (e) {
      console.error("Failed to parse URL stocks:", e);
    }
  }

  if (initialStocks.length === 0) {
    const storedStocks = JSON.parse(localStorage.getItem("myStocks")) || [];
    initialStocks = storedStocks;
  }
  
  let selectedRange = urlRange || "3y";
  let useCustomDate = selectedRange === "custom";
  let startDate = urlStart || defaultStartDate;
  let endDate = urlEnd || defaultEndDate;
  
  if (!useCustomDate) {
    let start;
    switch (selectedRange) {
      case "6m": start = subMonths(today, 6); break;
      case "1y": start = subMonths(today, 12); break;
      case "3y": start = subMonths(today, 36); break;
      case "5y": start = subMonths(today, 60); break;
      case "max": start = new Date("2000-01-01"); break;
      default: start = subMonths(today, 36);
    }
    startDate = format(start, "yyyy-MM-dd");
    endDate = defaultEndDate;
  }
  
  if (urlStocks && initialStocks.length >= 3) {
     isReady = true;
  } else {
     isReady = false; 
  }

  return {
    stocks: initialStocks,
    selectedRange: selectedRange,
    useCustomDate: useCustomDate,
    startDate: startDate,
    endDate: endDate,
    initialK: urlK ? parseInt(urlK) : null,
    isReady: isReady 
  };
};